<template>
<div>
    <div v-if=showgraph>
        <TrafficPlot :key=myKey chartId="traffic" class="chart-wrapper" style="height:350px;margin-bottom:0px;" :period=period></TrafficPlot>
    </div>
    <div v-if=showtable>
        <TabulateTraffic :key=myKey class="chart-wrapper" style="margin-top:35px;" :period=period></TabulateTraffic>
    </div>

    <b-button type="button" :pressed.sync="showtable" variant="outline-primary" class="float-right"><i class="icon-grid"></i></b-button>
    <b-button type="button" :pressed.sync="showgraph" variant="outline-primary" class="float-right"><i class="icon-graph"></i></b-button>
    <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
        <b-form-radio-group class="mr-3" id="period" buttons button-variant="outline-secondary" v-model="period" name="period" @input="reload">
            <b-form-radio class="mx-0" value="D">D</b-form-radio>
            <b-form-radio class="mx-0" value="M">M</b-form-radio>
            <b-form-radio class="mx-0" value="Y">Y</b-form-radio>
        </b-form-radio-group>
    </b-button-toolbar>

</div>
</template>

<script>
import TrafficPlot from './TrafficPlot'
import TabulateTraffic from './TabulateTraffic'

export default {
    components: {
        TrafficPlot,
        TabulateTraffic,
    },
    props: {},
    data() {
        return {
            period: 'M',
            myKey: 0,
            showgraph: true,
            showtable: false,

        }
    },
    methods: {
        reload() {
            this.myKey += 1;
        },
    },

}
</script>
